import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import TableHeader from '../../atoms/table/TableHeader';
import TableHeaderCell from '../../atoms/table/TableHeaderCell';
import { CopyrightCheckerDossiersOverviewTableColumns as Cols } from '../../../config/CopyrightCheckerDossiersOverviewTable';
const StyledHeaderCell = styled(TableHeaderCell) `
    color: ${props => props.theme.primary.base};
`;
function CopyrightCheckerDossierOverviewTableHeader() {
    const { t } = useTranslation();
    return (_jsxs(TableHeader, { children: [_jsx(StyledHeaderCell, { children: t(Cols.Source.translateKey) }), _jsx(StyledHeaderCell, { children: t(Cols.DetectionCount.translateKey) }), _jsx(StyledHeaderCell, { children: t(Cols.FullDetectionsCount.translateKey) }), _jsx(StyledHeaderCell, { children: t(Cols.EmbeddedDetectionsCount.translateKey) }), _jsx(StyledHeaderCell, { children: t(Cols.Status.translateKey) }), _jsx(StyledHeaderCell, { align: "right", maxWidth: Cols.Actions.maxWidth })] }));
}
export default CopyrightCheckerDossierOverviewTableHeader;
